<script>
  export let message = '';
  export let visible = false;
</script>

{#if visible}
<div class="tooltip show">
  <div class="tooltip-inner">
    {message}
  </div>
</div>
{/if}

<style>
  .tooltip {
    position: fixed; /* Use fixed to position it relative to the viewport */
    top: 50%;        /* Center vertically */
    left: 50%;       /* Center horizontally */
    transform: translate(-50%, -50%); /* Adjust the center point */
    background-color: rgba(124, 150, 254, 0.8);
    color: rgb(95, 159, 255);
    padding: 20px;  /* Increase padding for a larger window */
    border-radius: 2px;
    transition: opacity 0.3s;
    z-index: 1000; /* Ensure it stays above other content */
    max-width: 80%; /* Ensure it doesn't go off-screen on smaller devices */
    text-align: center; /* Center the text */
  }

  .tooltip-inner {
    font-size: 20px;
  }

  .show {
    visibility: visible;
    opacity: 0;
  }
</style>
